import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var LaptopStar = function LaptopStar(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor,
    secondaryColor = _ref.secondaryColor;
  var primary = ignoreColor ? undefined : color;
  return /*#__PURE__*/_jsxs("svg", {
    width: size,
    height: size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M45 44H3c-1.65 0-3-1.35-3-3v-5h48v5c0 1.65-1.35 3-3 3zM2 38v3c0 .55.45 1 1 1h42c.55 0 1-.45 1-1v-3H2z",
      fill: primary
    }), /*#__PURE__*/_jsx("path", {
      d: "M45 37h-2V8c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1v29H3V8c0-1.65 1.35-3 3-3h36c1.65 0 3 1.35 3 3v29zM42 40h-2v3h2v-3zM38 40h-2v3h2v-3zM34 40h-2v3h2v-3z",
      fill: primary
    }), /*#__PURE__*/_jsx("path", {
      d: "M32.763 33.862l-8.25-5.025-8.25 5.025 2.25-9.237L11 18.538l9.887-1L24.526 9l3.638 8.538 9.887 1-7.537 6.087 2.25 9.237zm-8.25-7.375l5.162 3.138-1.4-5.762L33 20.038l-6.225-.638-2.25-5.3-2.25 5.3-6.225.638 4.725 3.825-1.4 5.762 5.137-3.137z",
      fill: secondaryColor || primary
    })]
  });
};
export default LaptopStar;